export const Namespace = 'custom_element';

export const enum TranslationKeys {
  UpgradePremium = 'custom_element_gfpp_upgrade_premium_info_text',
  UpgradeNoAds = 'custom_element_gfpp_upgrade_no_ads_info_text',
  ConnectDomain = 'Custom_element_gfpp_connect_domain_info_text',
  BlocksUpgrade = 'custom_element_gfpp_blocks_upgrade_premium_info_text',
}
